import { get } from 'lodash';
import { fetchRecipe, recipePrintUri, selectRecipe } from 'logic/recipe';

import {
  mapIsFavouriteRecipes,
  selectFavouriteRecipeIds,
  toggleFavouriteRecipe,
} from 'logic/favourite';

import {
  fetchMember,
  selectMember,
  selectPrintTooltip,
  selectSubscription,
} from 'logic/member';

export const RecipePreview = {
  bindings: {
    recipeId: '<',
    showOn: '<',
  },

  template: `
    <div
      id="modalRecipePreview"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="Preview Recipe"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header d-flex align-items-center mx-1">
            <h2 class="modal-title mb-0">
              {{ $ctrl.recipe.name }}
            </h2>
            <button-print
              ng-hide="true"
              uri="{{ $ctrl.printUri }}"
              tooltip="$ctrl.tooltip"
              ng-click="$ctrl.refetchMember()"
              ng-if="$ctrl.subscription.canPrint">
            </button-print>
            <button-primary data-dismiss="modal">
              x
            </button-primary>
          </div>
          <div class="modal-body text-left">
            <recipe-detail
              recipe="$ctrl.recipe"
              is-favourite="$ctrl.recipe.isFavourite"
              on-favourite="$ctrl.toggleFavouriteRecipe({
                memberId: $ctrl.member.id,
                recipeId: $ctrl.recipe.id,
                isFavourite: $ctrl.recipe.isFavourite,
              })">
            </recipe-detail>
          </div>
          <div class="modal-footer">
            <button-primary data-dismiss="modal">
              Close
            </button-primary>
          </div>
        </div>
      </div>
    </div>`,

  controller($element, $ngRedux, $timeout) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(
          this.mapState.bind(this),
          this.mapDispatch()
        );

        this.unsubscribe = connect(this);
        this.modal = $element.find('#modalRecipePreview');
      },

      $onChanges(changes) {
        if (get(changes, 'showOn.currentValue') === true) {
          this.show();
        }
      },

      $onDestroy() {
        this.unsubscribe();
      },

      refetchMember() {
        this.tooltip && $timeout(() => this.fetchMember(this.member.id), 500);
      },

      show() {
        if (this.recipe.id !== this.recipeId || !this.recipe.nutritionSummary) {
          this.fetchRecipe(this.recipeId);
        }

        this.modal.modal('show');
      },

      hide() {
        this.modal.modal('hide');
      },

      mapState({ favourite, member, recipe }) {
        const subscription = selectSubscription(member);

        return {
          subscription,
          member: selectMember(member),
          tooltip: selectPrintTooltip(member),
          printUri:
            subscription.canPrint &&
            recipePrintUri(this.recipeId, subscription.id),
          recipe: mapIsFavouriteRecipes(
            selectRecipe(recipe, this.recipeId),
            selectFavouriteRecipeIds(favourite)
          ),
        };
      },

      mapDispatch() {
        return {
          fetchMember,
          fetchRecipe,
          toggleFavouriteRecipe,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Recipe/RecipePreview.js